import { CHARTING_REDIRECT_PATH } from "@src/appV2/redesign/Charting/constants";
import { Button } from "@src/appV2/redesign/components/Button";
import { type History } from "history";

import { ShiftBottomSheetBookabilityCriteriaCard } from "./BookabilityCriteriaCard";

export function BaseIncompleteChartingCard(props: { history: History }) {
  const { history } = props;
  return (
    <ShiftBottomSheetBookabilityCriteriaCard
      intent="error"
      title="You have incomplete charting"
      description="This workplace does not allow professional with incomplete charting anywhere to book or work shifts."
      illustrationType="quiz-error"
      footer={
        <Button
          size="large"
          variant="outlined"
          sx={{ width: "100%" }}
          onClick={() => {
            history.push(CHARTING_REDIRECT_PATH);
          }}
        >
          View Details
        </Button>
      }
    />
  );
}
